// extracted by mini-css-extract-plugin
export default {"bannerBody":"THBM1U","text":"qlLIkZ","cta":"bJUpKI","searchFadeIn":"SFygWy"};